__turbopack_context__.v({
  "artworkBody": "student-artwork-module-scss-module__PqVmMG__artworkBody",
  "artworkGrade": "student-artwork-module-scss-module__PqVmMG__artworkGrade",
  "artworkImage": "student-artwork-module-scss-module__PqVmMG__artworkImage",
  "artworkImageButton": "student-artwork-module-scss-module__PqVmMG__artworkImageButton",
  "artworkImageGrid": "student-artwork-module-scss-module__PqVmMG__artworkImageGrid",
  "artworkImageWrapper": "student-artwork-module-scss-module__PqVmMG__artworkImageWrapper",
  "artworkStudent": "student-artwork-module-scss-module__PqVmMG__artworkStudent",
  "artworkTitle": "student-artwork-module-scss-module__PqVmMG__artworkTitle",
  "noImageSvg": "student-artwork-module-scss-module__PqVmMG__noImageSvg",
});
